import { Content, Sidebar, SidebarLayout, Logo } from 'mds-web-ui'
import {
  ActiveLink as MDSActiveLink,
  Link,
  ButtonLinkLocal
} from 'mds-web-ui/components/Link/GatsbyLink'
import { Box, Text } from 'mds-web-ui'
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'

import DocsContent from '../Docs/Content'
import { DocsSearch } from '../Docs/DocsSearch'
import { SkipToContent } from '../Docs/SkipLink'
import { useScrollRestoration } from '../Docs/useScrollRestoration'
import { ActiveLink } from '../Link'
import { NavTabsVH, SupportLink } from '../NavTabs'
import SEO from '../SEO'
import LanguageTags from './Languagetags'
import { useGetWhatsNews } from './Nav'
import { WhatsNewWrapper } from './Wrapper'
// import { FreeTrialIndicator } from './FreeTrialIndicator'

const NavLinkText = ({ children }) => (
  <Text
    color="grayapptitle"
    fontSize={15}
    fontWeight="inherit"
    mb={1}
    display="block"
  >
    {children}
  </Text>
)

const NavLinkDate = ({ date }) => {
  const d = new Date(date)
  return (
    <Text color="#727272" fontSize={11} fontWeight="normal">
      {d.toLocaleDateString()}
    </Text>
  )
}

const NavLink = ({ d }) => {
  const url = d.fields.slug.replace('/whatsnew', '/new')

  return (
    <div>
      <ActiveLink
        to={url}
        partiallyActive={true}
        lineHeight={1}
        p={1}
        ml={-1}
        mb={2}
      >
        <NavLinkText>{d.frontmatter.title}</NavLinkText>
        <NavLinkDate date={d.frontmatter.date} />
      </ActiveLink>
    </div>
  )
}

const Nav = ({ slug, app }) => {
  const navData = useGetWhatsNews({ slug })
  return (
    <Box as="nav" px={3} mb={[1, 2]}>
      <SupportLink />
      <NavTabsVH app={app} />
      {navData.map((d, i) => (
        <NavLink d={d} key={i} />
      ))}
    </Box>
  )
}

const Layout = ({ showNav, ...props }) =>
  showNav ? (
    <SidebarLayout bg="white" {...props} />
  ) : (
    <Box bg="white" {...props} />
  )

const DocsWrapper = ({ showNav, slug, app, children }) => {
  const { ref: scrollRef, onScroll } = useScrollRestoration(slug)

  if (showNav)
    return (
      <>
        <SkipToContent />
        <Sidebar>
          <Box css={{ alignSelf: 'center' }} pl={14} pr={3}>
            <Logo LinkComponent={Link} />
          </Box>
          <Nav slug={slug} app={app} />
        </Sidebar>
        <Content
          showFooter
          showHelp
          currentSite="home"
          pt={[3, 4]}
          px={[3, 3, 4, 5]}
          ref={scrollRef}
          mainProps={{ onScroll }}
          LinkComponent={MDSActiveLink}
          ButtonLinkComponent={ButtonLinkLocal}
        >
          <DocsSearch />
          {children}
        </Content>
      </>
    )
  else return <WhatsNewWrapper>{children}</WhatsNewWrapper>
}

const WhatsNew = ({
  title,
  description,
  excerpt,
  children,
  image,
  slug,
  date,
  app,
  tableOfContents,
  lang = 'en',
  showNav = false
}) => {
  // fix "automatically translated from English" links
  // if (showNav) body = body.replace(/\/whatsnew\/en\//g, '/new/en/')

  return (
    <Layout showNav={showNav}>
      <Helmet title={title} />
      <LanguageTags
        baseURL={showNav ? 'new' : 'whatsnew'}
        slug={slug}
        lang={lang}
      />
      <SEO
        title={title}
        description={description ? description : excerpt}
        image={image}
        path={slug}
        isArticle={true}
        noindex={!showNav}
      />
      <DocsWrapper showNav={showNav} slug={slug} app={app}>
        <DocsContent
          title={title}
          section={date}
          slug={slug}
          baseURL={showNav ? 'new' : 'whatsnew'}
          tableOfContents={tableOfContents}
        >
          {/* <FreeTrialIndicator /> */}
          {children}
        </DocsContent>
      </DocsWrapper>
    </Layout>
  )
}

WhatsNew.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  date: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  tableOfContents: PropTypes.object,
  showNav: PropTypes.bool,
  image: PropTypes.shape({
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  })
}

export default WhatsNew
